module.exports = __webpack_public_path__ + "static/media/aids.db5ee5c5.wav";